export default function SeoManager() {
  return null;
}
